module.exports = __webpack_public_path__ + "img/project-5.c36bc3be.jpg";